import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/studio/m1-l.png'
import _imports_1 from '@/assets/images/studio/m1-r.png'
import _imports_2 from '@/assets/images/studio/m2-l.png'
import _imports_3 from '@/assets/images/studio/m2-m.png'
import _imports_4 from '@/assets/images/studio/m2-r.png'
import _imports_5 from '@/assets/images/studio/m3-l-1.png'
import _imports_6 from '@/assets/images/studio/m3-l-2.png'
import _imports_7 from '@/assets/images/studio/m3-l-3.png'
import _imports_8 from '@/assets/images/studio/m3-r-t.png'
import _imports_9 from '@/assets/images/studio/m3-r-b.png'


const _hoisted_1 = { class: "header-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "role-wrap" }
const _hoisted_4 = { class: "role-scene" }
const _hoisted_5 = { class: "role-title" }
const _hoisted_6 = { class: "role-title-tips" }
const _hoisted_7 = { class: "role-wrap2" }
const _hoisted_8 = { class: "role-scene" }
const _hoisted_9 = { class: "scene-type" }
const _hoisted_10 = { class: "scene-content" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "role-scene2" }
const _hoisted_13 = { class: "room-pic" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "solution" }
const _hoisted_16 = { class: "solution-content" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "package" }
const _hoisted_21 = { class: "package-list" }
const _hoisted_22 = { class: "img-div" }
const _hoisted_23 = { class: "img-div" }

import { ref, reactive, onMounted, watch, onUnmounted } from 'vue';
import { asynchronousRetrieval } from '@/utils';
import router from '@/router';

export default /*@__PURE__*/_defineComponent({
  __name: 'StudioView',
  setup(__props) {

const loadUrl: any = ref({})
const activeRoleIndex = ref(0)
const singlePointDataList = ref([
  {
    name: '平面识别',
    url: ''
  },
  {
    name: '图像识别',
    url: ''
  },
  {
    name: '单场景识别',
    url: ''
  },
  {
    name: '身体识别',
    url: ''
  },
  {
    name: '人脸识别',
    url: ''
  },
  {
    name: '手势识别',
    url: ''
  }
]);
const roleTextList = ref(
  [
    {
      title: '构建AR大场景',
      tips: 'SAAS化部署，无缝开发沉浸式世界里的增强现实内容，所有这些都在您的网络浏览器中创建和部署',
      url: require('@/assets/images/home/room-platform.png'),
      activeClass: 'room-bg'
    },
    {
      title: 'XR眼镜端',
      tips: '通过账号进行登陆并选择相应场景进入相关展示内容。根据现场虚与实的融合进行体验',
      url: require('@/assets/images/home/ar-rokid.png'),
      activeClass: 'glass-bg'
    },
    {
      title: '移动端',
      tips: '游客模式使用移动端混空Studio\nAPP或混空微信小程序进行空间互动体验(设备需支持ARkit/ARcore)。',
      url: loadUrl.value.web_platform,
      activeClass: 'web-bg'
    }
  ]
)
const solutionBannerList: any = ref(
  [
    {
      title: '空间数字化建图',
      content: ['多源采集：支持多种采集设备', '自研VPS定位：实现厘米级视觉定位精度'],
      url: require('@/assets/images/studio/solution-l-icon1.png'),
      a_url: require('@/assets/images/studio/solution-l-icon1A.png'),
    },
    {
      title: '智能场景创作',
      content: ['虚拟空间装修：', '3D 模型 / 动画 / 数字人', '交互逻辑一站式配置'],
      url: require('@/assets/images/studio/solution-l-icon2.png'),
      a_url: require('@/assets/images/studio/solution-l-icon2A.png'),
    },
    {
      title: '跨端部署',
      content: ['多形态交付：智能眼镜、手机等多端部署', '实时数据同步：可远程更新，内容动态迭代'],
      url: require('@/assets/images/studio/solution-l-icon3.png'),
      a_url: require('@/assets/images/studio/solution-l-icon3A.png'),
    },
    {
      title: '数实融合体验',
      content: ['多端体验数实融合互动场景'],
      url: require('@/assets/images/studio/solution-l-icon4.png'),
      a_url: require('@/assets/images/studio/solution-l-icon4A.png'),
    }
  ]
)

onMounted(async () => {
  const studio_banner: any = await asynchronousRetrieval('webimg/images/vps-img2.png');
  const web_platform: any = await asynchronousRetrieval('webimg/images/home/web-platform.png');
  const collect_maps: any = await asynchronousRetrieval('webimg/video/collect-maps.gif');
  const creating_scenes: any = await asynchronousRetrieval('webimg/video/creating-scenes.gif');
  const rapid_deployment: any = await asynchronousRetrieval('webimg/images/studio/rapid-deployment.png');
  const virtual_real_fusion: any = await asynchronousRetrieval('webimg/gif/virtual-real-fusion.gif');
  const glass_platform_bg: any = await asynchronousRetrieval('webimg/images/home/glass_platform_bg.png');
  const plane_recognition: any = await asynchronousRetrieval('webimg/images/studio/plane-recognition.gif');
  const hand_recognition: any = await asynchronousRetrieval('webimg/images/studio/hand-recognition.gif');
  const single_scene: any = await asynchronousRetrieval('webimg/images/studio/single-scene.gif');
  const body_recognition: any = await asynchronousRetrieval('webimg/images/studio/body-recognition.gif');
  const image_recognition: any = await asynchronousRetrieval('webimg/images/studio/image-recognition.gif');
  const face_recognition: any = await asynchronousRetrieval('webimg/images/studio/face-recognition.gif');
  const room_recognition: any = await asynchronousRetrieval('webimg/gif/room.gif');
  loadUrl.value = { studio_banner, web_platform, collect_maps, creating_scenes, rapid_deployment, virtual_real_fusion, glass_platform_bg, room_recognition }

  roleTextList.value[2].url = web_platform
  solutionBannerList.value[0].i_url = collect_maps
  solutionBannerList.value[1].i_url = creating_scenes
  solutionBannerList.value[2].i_url = rapid_deployment
  solutionBannerList.value[3].i_url = virtual_real_fusion
  singlePointDataList.value[0].url = plane_recognition;
  singlePointDataList.value[1].url = image_recognition;
  singlePointDataList.value[2].url = single_scene;
  singlePointDataList.value[3].url = body_recognition;
  singlePointDataList.value[4].url = face_recognition;
  singlePointDataList.value[5].url = hand_recognition;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: loadUrl.value.studio_banner
      }, null, 8, _hoisted_2),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "video-text" }, [
        _createElementVNode("div", { class: "logo-text" }, [
          _createElementVNode("span", null, "混空"),
          _createElementVNode("span", null, "Studio")
        ]),
        _createElementVNode("div", { class: "link-room" }, "AI+AR元宇宙内容创作与分发")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "专业的元宇宙智能创作工具", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title-tips" }, "智能生成数字空间  智能创作工具链  跨端智能互动体验", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleTextList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(item.activeClass),
              key: index
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.tips), 1)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "多种识别方式，更灵活、更有趣", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title-tips2" }, "单点识别", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlePointDataList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_10, [
                (item.url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.url
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-tips2" }, "空间识别", -1)),
      _createElementVNode("div", _hoisted_12, [
        _cache[5] || (_cache[5] = _createElementVNode("div", null, "扫描空间特征，", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", null, "识别成功后，在立体空间中出现虚拟互动内容", -1)),
        _createElementVNode("div", _hoisted_13, [
          (loadUrl.value.room_recognition)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: loadUrl.value.room_recognition
              }, null, 8, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"advantage\" data-v-51f2022e><div class=\"title deep\" data-v-51f2022e>我们的优势</div><div class=\"title-tips deep\" data-v-51f2022e>更低的创作门槛，更丰富的功能</div><div class=\"m1\" data-v-51f2022e><div data-v-51f2022e><img class=\"m1-img\" src=\"" + _imports_0 + "\" data-v-51f2022e><div class=\"t1\" data-v-51f2022e>更准确的空间定位</div><div class=\"t2\" data-v-51f2022e>自研空间定位算法，原米级视觉定位空间导航精准， 支持大空间定位</div></div><div data-v-51f2022e><img src=\"" + _imports_1 + "\" data-v-51f2022e><div class=\"t1\" data-v-51f2022e>更快速的交付部署</div><div class=\"t2\" data-v-51f2022e>SaaS化服务快速调整内容布局2天内完成空间构建现场体验式交付</div></div></div><div class=\"m2\" data-v-51f2022e><img class=\"img2\" src=\"" + _imports_2 + "\" data-v-51f2022e><img class=\"img1\" src=\"" + _imports_3 + "\" data-v-51f2022e><img class=\"img3\" src=\"" + _imports_4 + "\" data-v-51f2022e><div class=\"t1\" data-v-51f2022e>更简单的场景编辑</div><div class=\"t2\" data-v-51f2022e>3D场景地图， 可视化交互“拖拉拽“操作，所“建”即所得</div></div><div class=\"m3\" data-v-51f2022e><div data-v-51f2022e><div class=\"m3-icons\" data-v-51f2022e><img src=\"" + _imports_5 + "\" data-v-51f2022e><img src=\"" + _imports_6 + "\" data-v-51f2022e><img src=\"" + _imports_7 + "\" data-v-51f2022e></div><div class=\"t1\" data-v-51f2022e>更多平台支持应用</div><div class=\"t2\" data-v-51f2022e>XR/VR眼镜、移动端APP、小程序AR、Web AR</div></div><div data-v-51f2022e><div class=\"m3-r\" data-v-51f2022e><img src=\"" + _imports_8 + "\" data-v-51f2022e><img src=\"" + _imports_9 + "\" data-v-51f2022e></div><div class=\"t1\" data-v-51f2022e>更强的内容扩展性</div><div class=\"t2\" data-v-51f2022e>数字多媒体动画、特效手势互动、3D数字人</div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_15, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, "混空Studio使用教程", -1)),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title-tips" }, "一站式可视化编辑，轻松实现AR创作与开发", -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(solutionBannerList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", null, [
                (item.i_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.i_url
                    }, null, 8, _hoisted_17))
                  : _createCommentVNode("", true),
                (item.v_url)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      src: item.v_url,
                      autoplay: "",
                      loop: "",
                      muted: "",
                      playsinline: "",
                      "webkit-playsinline": ""
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: item.a_url
                }, null, 8, _hoisted_19),
                _createElementVNode("span", null, _toDisplayString(item.title), 1),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (e, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createElementVNode("span", null, _toDisplayString(e), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", null, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title deep" }, "按需选择 灵活购买", -1)),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title-tips deep" }, "混空Studio产品体系", -1)),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_22, [
              _cache[12] || (_cache[12] = _createStaticVNode("<div data-v-51f2022e>空间识别定位</div><div class=\"suv-title2\" data-v-51f2022e>标准服务包含</div><div class=\"service-content\" data-v-51f2022e><div data-v-51f2022e><span data-v-51f2022e>定位面积</span><span data-v-51f2022e>服务时长</span><span data-v-51f2022e>并发数量</span><span data-v-51f2022e>项目数量</span></div><div data-v-51f2022e><span data-v-51f2022e>小程序访问次数</span><span data-v-51f2022e>素材空间容量</span></div></div><div class=\"suv-title2\" style=\"font-size:20rem;\" data-v-51f2022e>功能包含</div><div class=\"function-box\" data-v-51f2022e><div data-v-51f2022e>全平台空间定位功能</div><div data-v-51f2022e>【小程序端】平面AR</div><div data-v-51f2022e>【小程序端】人脸AR</div><div data-v-51f2022e>【小程序端】图像AR</div></div><div class=\"contact-tips\" data-v-51f2022e>可根据您的项目实际情况，购买标准服务(支持按需扩展单项)</div>", 6)),
              _createElementVNode("div", {
                class: "contact-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/counselling')))
              }, "立即咨询")
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[13] || (_cache[13] = _createStaticVNode("<div data-v-51f2022e>单点识别定位</div><div class=\"suv-title2\" data-v-51f2022e>标准服务包含</div><div class=\"service-content\" data-v-51f2022e><div data-v-51f2022e><span data-v-51f2022e>单点AR识别</span><span data-v-51f2022e>服务时长</span><span data-v-51f2022e>项目数量</span></div><div data-v-51f2022e><span data-v-51f2022e>小程序访问次数</span><span data-v-51f2022e>素材空间容量</span></div></div><div class=\"suv-title2\" style=\"font-size:20rem;\" data-v-51f2022e>功能包含</div><div class=\"function-box\" data-v-51f2022e><div data-v-51f2022e>【小程序端】平面AR</div><div data-v-51f2022e>【小程序端】图像AR</div><div data-v-51f2022e>【小程序端】单场景AR</div><div data-v-51f2022e>【小程序端】人脸AR</div><div data-v-51f2022e>【小程序端】身体AR</div><div data-v-51f2022e>【小程序端】手势AR</div></div><div class=\"contact-tips\" data-v-51f2022e>可根据您的项目实际情况，购买标准服务(支持按需扩展单项)</div>", 6)),
              _createElementVNode("div", {
                class: "contact-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/counselling')))
              }, "立即咨询")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})